import React from 'react';

import lamb_chicken from '../../assets/home/lamb_chicken_comparison.png';

//TODO - This can be broken down to smaller similar components

const FeatureChickenOrLamb = () => {
  return (
    <div className="def-w-max">
      <div className="ing-hdr-wrap text-center">
        <h2 className="mgn-bot-20">Chicken or Lamb?</h2>
        <p>You choose & easily change any time you like</p>
        <p>from your dashboard</p>
      </div>
      {/* <div className="how-wrapper text-center"> */}
        {/* <div className="row">
          <div className="col-12 col-sm-4">
            <div className="img-txt-wrapper on-sz-mgnbt">
                <img src={lamb_chicken} />
              </div>
            </div>
        </div> */}
        <div className="row justify-content-center">
          <div className="col-12"> {/* Updated for better responsiveness */}
            <div className="img-wrapper on-sz-mgnbt">
              <img src={lamb_chicken} className="img-fluid" alt="Chicken or Lamb Comparison" />
            </div>
          </div>
        </div>
      {/* </div> */}
    </div>
  );
};

export default FeatureChickenOrLamb;
